/**
 * Valida que un texto contenga sólo números
 * @param text
 * @returns
 */
export const isNumericText = (text: string): boolean => {
  const regex = /^[0-9]*$/;
  return regex.test(text);
};
